export default __webpack_public_path__ + "static/media/awarding_certificate.aff3e018.jpg";